// Generated by Melange

import * as Buhta_core__Auth from "../../../../../../packages/core/lib/Auth.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Buhta_landing__NavbarCabinetButton from "./NavbarCabinetButton.js";
import * as Buhta_landing__NavbarCabinetMenuMobile from "./NavbarCabinetMenuMobile.js";
import * as Buhta_landing__NavbarMenuItem from "./NavbarMenuItem.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function NavbarCabinetLink(Props) {
  let theme = Props.theme;
  let cabinetMenuActive = Props.cabinetMenuActive;
  let setCabinetMenuActive = Props.setCabinetMenuActive;
  let setMobileMenuActive = Props.setMobileMenuActive;
  const match = Buhta_core__Auth.IdentityContext.useIdentity(undefined);
  const identity = match[0];
  const intl = ReactIntl.useIntl();
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const country = Buhta_landing__Route.getCountry(undefined);
  if (!/* tag */ (typeof identity === "number" || typeof identity === "string") && identity.TAG === /* Authorized */ 0) {
    return JsxRuntime.jsx("div", {
      children: deviceType === "mobile" ? JsxRuntime.jsx(Buhta_landing__NavbarCabinetMenuMobile.make, {
          theme: theme,
          onLogout: (() => {
                  window.location.href = "/logout";
                }
          ),
          identity: identity._0,
          cabinetMenuActive: cabinetMenuActive,
          setCabinetMenuActive: setCabinetMenuActive,
          setMobileMenuActive: setMobileMenuActive
        }) : JsxRuntime.jsx(Buhta_landing__NavbarCabinetButton.make, {
          theme: theme
        }),
      className: "relative flex items-center h-full"
    });
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Buhta_landing__NavbarMenuItem.make, {
          label: Buhta_landing__I18n.trans(intl, "help"),
          color: theme === "dark" ? "text-white" : "text-primary",
          path: "/wiki"
        }),
        className: "hidden lg:flex"
      }),
      country !== /* COUNTRY_UZB */ 3 ? JsxRuntime.jsx("a", {
          children: Buhta_landing__I18n.trans(intl, "sign_in"),
          className: "bg-primary hover:bg-primary-hover active:bg-primary-active text-white py-1.5 px-4 ml-6 rounded-md inline-block h-10 paragraph-large",
          href: "/login"
        }) : null
    ],
    className: "flex items-center"
  });
}

const make = NavbarCabinetLink;

export {
  make,
}
/* Buhta_core__Auth Not a pure module */
